export default __webpack_public_path__ + "static/media/FeaturedJobsTitle.42d7e27a.png";